// Using the Animate on Scroll Library
// https://michalsnik.github.io/aos/
import AOS from "aos";

const init = () => {
  AOS.init({
    duration: 1300,
    once: true
  });
}

// Init on initial page load
init()
